import { render, staticRenderFns } from "./supplementList.vue?vue&type=template&id=439090b8&scoped=true"
import script from "./supplementList.vue?vue&type=script&lang=ts"
export * from "./supplementList.vue?vue&type=script&lang=ts"
import style0 from "./supplementList.vue?vue&type=style&index=0&id=439090b8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "439090b8",
  null
  
)

export default component.exports